<template>
  <div>
    <button type="button" @click="$emit('clicked', $event)" class="btn btn-link px-0 text-brand1">
      <div class="d-flex align-items-center">
        <span class="icon icon-navigation_pfeil_links mr-1" aria-hidden="true"></span>
        <span class="hover-underline">{{ $t(i18nMessage) }}</span>
      </div>
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LinkBack',
  props: {
    i18nMessage: {
      type: String,
      default: 'common.backToOverview'
    }
  }
});
</script>

<style scoped>
.icon{
  font-size: 24px;
  padding-top:2px;
}
</style>
